export const NOTIFICATION_TYPES_MAPPING = {
  CONVERSATION_MENTION: ['i-lucide-at-sign', 'text-n-blue-11'],
  CONVERSATION_ASSIGNMENT: ['i-lucide-chevrons-right', 'text-n-blue-11'],
  CONVERSATION_CREATION: ['i-lucide-mail-plus', 'text-n-blue-11'],
  PARTICIPATING_CONVERSATION_NEW_MESSAGE: [
    'i-lucide-message-square-plus',
    'text-n-blue-11',
  ],
  ASSIGNED_CONVERSATION_NEW_MESSAGE: [
    'i-lucide-message-square-plus',
    'text-n-blue-11',
  ],
  SLA_MISSED_FIRST_RESPONSE: ['i-lucide-heart-crack', 'text-n-ruby-11'],
  SLA_MISSED_NEXT_RESPONSE: ['i-lucide-heart-crack', 'text-n-ruby-11'],
  SLA_MISSED_RESOLUTION: ['i-lucide-heart-crack', 'text-n-ruby-11'],
  // NooviChat: notificações do Pipeline. As chaves são
  // `notificationType.toUpperCase()` (InboxCard.vue) e batem 1:1 com os tipos
  // do enum em app/models/notification.rb. Sem elas o InboxCard caía no `|| []`
  // e renderizava um ícone vazio.
  PIPELINE_CARD_ASSIGNED: ['i-lucide-user-plus', 'text-n-blue-11'],
  PIPELINE_CARD_MOVED: ['i-lucide-arrow-right-left', 'text-n-blue-11'],
  PIPELINE_CARD_WON: ['i-lucide-trophy', 'text-n-teal-11'],
  PIPELINE_CARD_LOST: ['i-lucide-circle-x', 'text-n-slate-11'],
  PIPELINE_SLA_EXCEEDED: ['i-lucide-alarm-clock', 'text-n-ruby-11'],
  PIPELINE_ACTIVITY_REMINDER: ['i-lucide-bell', 'text-n-amber-11'],
  // NooviChat: notificações do Lead Score. Mesmo contrato das do Pipeline —
  // as chaves são o enum de app/models/notification.rb em maiúsculas.
  LEAD_SCORE_CATEGORY_CHANGE: ['i-lucide-gauge', 'text-n-blue-11'],
  LEAD_BECAME_HOT: ['i-lucide-flame', 'text-n-ruby-11'],
  BULK_RECALCULATE_COMPLETED: ['i-lucide-refresh-cw', 'text-n-teal-11'],
};
